(() => {
  if (window.ccCartTotalsBound) return;
  window.ccCartTotalsBound = true;
  const money = cents => new Intl.NumberFormat('pl-PL', {style:'currency',currency:'PLN'}).format(cents / 100);
  const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const choiceKey = 'cc-delivery-explicit-choice-v1';
  let explicitChoice = false;
  try { explicitChoice = sessionStorage.getItem(choiceKey) === '1'; } catch (_) {}
  let queued = false, defaultApplied = false;
  // A remembered pickup point is not an explicit delivery choice this session.
  // Capture before the integration consumes the click; never override a fresh choice.
  document.addEventListener('click', event => {
    if (!event.isTrusted) return;
    const action = event.target.closest?.('[data-inpost-summary-action]');
    if (!action || action.dataset.inpostUnavailable === 'true') return;
    if (!['choose-rate', 'select', 'change', 'use-remembered'].includes(action.dataset.inpostSummaryAction)) return;
    explicitChoice = true;
    try { sessionStorage.setItem(choiceKey, '1'); } catch (_) {}
  }, true);
  function update() {
    queued = false;
    const footer = document.querySelector('#main-cart-footer');
    const drawer = document.querySelector('cart-drawer');
    const views = [
      {scope: footer, total: footer?.querySelector('[data-cc-cart-total]')},
      {scope: drawer, total: drawer?.querySelector('[data-cc-total][data-cc-currency="PLN"]')}
    ];
    views.forEach(({scope, total}) => {
    if (!total) return;
    const products = Number(total.dataset.ccCartTotal ?? total.dataset.ccTotal);
    const rates = [...scope.querySelectorAll('.inpost-pickup-summary__rate')];
    const selected = rates.find(row => row.classList.contains('inpost-pickup-summary__rate--selected'));
    const defaultRate = rates.find(row => row.querySelector('[data-inpost-summary-action="select"][data-inpost-carrier="inpost"]:not([data-inpost-unavailable="true"])'));
    if (defaultRate && !defaultApplied && !explicitChoice) {
      defaultApplied = true;
      if (selected !== defaultRate) {
        defaultRate.querySelector('[data-inpost-summary-action="select"][data-inpost-carrier="inpost"]').click();
        schedule();
        return;
      }
    }
    const rate = selected || defaultRate;
    rates.forEach(row => { const active = !selected && row === defaultRate; if (row.classList.contains('cc-delivery-default') !== active) row.classList.toggle('cc-delivery-default', active); });
    let shipping = products >= 18000 ? 0 : 1499;
    let name = 'Paczkomat InPost';
    if (rate) {
      name = rate.querySelector('.inpost-pickup-summary__rate-name')?.textContent.trim() || name;
      if (rate.querySelector('.inpost-pickup-summary__rate-price-free')) shipping = 0;
      else {
        const raw = rate.querySelector('.inpost-pickup-summary__rate-price')?.textContent || '';
        const match = raw.replace(/\s/g,'').match(/(\d+)[,.](\d{2})/);
        if (match) shipping = Number(match[1]) * 100 + Number(match[2]);
      }
    }
    if (total.dataset.requiresShipping === 'false') { shipping = 0; name = 'niewymagana'; }
    setText(total.querySelector('[data-cc-delivery-name]'), '(' + name + ')');
    setText(total.querySelector('[data-cc-delivery-total]'), money(shipping));
    setText(total.querySelector('[data-cc-grand-total]'), money(products + shipping));
    setText(total.querySelector('[data-cc-shipping-name]'), name);
    setText(total.querySelector('[data-cc-shipping-price]'), money(shipping));
    setText(total.querySelector('[data-cc-total-label]'), 'Razem z dostawą');
    setText(total.querySelector('[data-cc-estimated]'), money(products + shipping));
    scope.querySelectorAll('#checkout, #CartDrawer-Checkout').forEach(button => setText(button.querySelector('.button__label') || button, 'Przejdź do płatności · ' + money(products + shipping)));
    });
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(update); } }
  function init() {
    update();
    new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class','data-cc-cart-total','data-cc-total']});
    document.addEventListener('change',schedule);
    document.addEventListener('inpost:pickup:selected',schedule);
    document.addEventListener('inpost:pickup:cleared',schedule);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
